module.exports = __webpack_public_path__ + "img/attention.e45986a4.svg";